<template>
  <div class="page-body page-vipRights_index">
    <div class="clearfix">
      <div class="fl w324 h300 mr18 userBox">
        <div class="clearfix">
          <div class="fl userBox-img">
            <img :src="userInfo.avatar" />
          </div>
          <div v-if="$store.getters.isLogin" class="fl w200">
            <div class="userBox-title h24">
              <span class="ellipsis-1 dib vam" style="width: 102px">{{
                userInfo.nickname
              }}</span>
              <VipIcon />
              <Logout class="fr" txt="[ 退出 ]" style="margin-top: 4px" />
            </div>
            <div class="userBox-info">
              <em>游戏账号：</em>{{ userInfo.account }}
            </div>
            <div class="userBox-info pointer">
              <em v-if="userLevel().exp >= 10 && userLevel().state !== 'active'"
                ><a href="/personal/vip-info" target="_blank">激活VIP></a></em
              >
              <em v-else @click="$router.push('/vip-rights/intro/counpon')"
                >我的特权></em
              >
            </div>
          </div>
          <div v-else class="fl w190 lh70">
            <a href="javascript:;" @click="$login">请登录</a>
          </div>
        </div>
        <div class="processArea clearfix">
          <div
            class="processArea-bar click"
            :data-prev="'VIP' + userLevel().level"
            :data-next="
              userLevel().level === 10
                ? '已满级'
                : 'VIP' + (userLevel().level + 1)
            "
            @click="$router.push('/vip-rights/growth-system')"
          >
            <span :style="barStyle">
              <div v-if="userLevel().exp" class="processArea-tip">
                VIP成长值：{{ userLevel().exp }}
              </div>
            </span>
          </div>
        </div>
        <div
          class="userBox_click-1 click"
          @click="$router.push('/vip-rights/intro/counpon')"
        ></div>
        <div
          class="userBox_click-2 click"
          @click="$router.push('/vip-rights/intro/first-pay')"
        ></div>
        <div
          class="userBox_click-3 click"
          @click="$router.push('/vip-rights/intro/vip-package')"
        ></div>
        <div
          class="userBox_click-4 click"
          @click="$router.push('/vip-rights/intro/more')"
        ></div>
      </div>
      <div class="fl w666 h300 clearfix">
        <CommonSwiper
          :autoplay="false"
          :options="swiperOptions"
          :slides="swiperList"
        >
          <div class="swiper-wrapper">
            <div
              v-for="(item, i) in swiperList"
              :key="i"
              class="swiper-slide ovh"
            >
              <a :href="item.jump_url" target="_blank">
                <img :src="item.img_url" :alt="item.title" />
              </a>
            </div>
          </div>
        </CommonSwiper>
      </div>
    </div>
    <div class="page-vipRights_index-title">
      <em>每月优惠券</em>
      VIP用户每月可以随机获得对应等级的优惠券，最高充值7.5折优惠哟
      <a
        href="javascript:;"
        class="fr blue"
        @click="$router.push('/vip-rights/intro/counpon')"
      >
        详细说明></a
      >
    </div>
    <div class="clearfix">
      <div
        v-for="i in 3"
        :key="i"
        class="w324 h160 fl hover"
        :class="{ mr18: i < 3 }"
        @click="$router.push('/vip-rights/intro/counpon')"
      >
        <img
          :src="
            `https://static2-youxi.a.88cdn.com/backend/xwgame/vip-right-banner-${i}.png`
          "
        />
        <div class="cover w324">
          <span
            >用户在迅雷游戏平台达到一定的VIP等级，即可在游戏内领取相应的礼包福利。</span
          >
        </div>
      </div>
    </div>
    <div class="page-vipRights_index-title">
      <em>免费领首充</em>
      VIP用户每月可以领取一定的首充次数。玩新游、去新服，我们来服务！
      <a
        href="javascript::"
        class="fr blue"
        @click="$router.push('/vip-rights/intro/first-pay')"
        >首充领取></a
      >
    </div>
    <div
      class="h160 clearfix"
      @click="$router.push('/vip-rights/intro/first-pay')"
    >
      <div class="w324 h180 fl mr18 block blue">
        <div class="page-vipRights_index-icon">
          <img src="~assets/img/right/6.png" alt="玩新游" />
          <div>玩新游</div>
        </div>
      </div>
      <div class="w324 h180 fl mr18 block blue">
        <div class="page-vipRights_index-icon">
          <img src="~assets/img/right/7.png" alt="去新服" />
          <div>去新服</div>
        </div>
      </div>
      <div class="w324 h180 fl block blue">
        <div class="page-vipRights_index-icon">
          <img src="~assets/img/right/8.png" alt="每月领" />
          <div>每月领</div>
        </div>
      </div>
    </div>
    <div class="page-vipRights_index-title">
      <em>VIP专属礼包</em>
      VIP玩家可以获得更好游戏礼包哟，让您处处领先！
      <a
        href="javascript::"
        class="fr blue"
        @click="$router.push('/vip-rights/intro/vip-package')"
      >
        <!-- <i class="icon-gift"></i> -->
        礼包领取></a
      >
    </div>
    <div
      class="h160 clearfix"
      @click="$router.push('/vip-rights/intro/vip-package')"
    >
      <div class="w324 h180 fl mr18 block red">
        <div class="page-vipRights_index-icon">
          <img src="~assets/img/right/9.png" alt="更多游戏" />
          <div>更多游戏</div>
        </div>
      </div>
      <div class="w324 h180 fl mr18 block red">
        <div class="page-vipRights_index-icon">
          <img src="~assets/img/right/10.png" alt="更多种类" />
          <div>更多种类</div>
        </div>
      </div>
      <div class="w324 h180 fl block red">
        <div class="page-vipRights_index-icon">
          <img src="~assets/img/right/11.png" alt="更高价值" />
          <div>更高价值</div>
        </div>
      </div>
    </div>
    <div class="page-vipRights_index-title">
      <em>其他特权</em>
      <a
        href="javascript:;"
        class="fr blue"
        @click="$router.push('/vip-rights/intro/more')"
        >详细说明></a
      >
    </div>
    <div class="clearfix" @click="$router.push('/vip-rights/intro/more')">
      <div class="w240 h180 fl mr16 block orange">
        <div class="page-vipRights_index-icon">
          <img src="~assets/img/right/12.png" alt="VIP专属客服" />
          <div>VIP专属客服</div>
        </div>
      </div>
      <div class="w240 h180 fl mr16 block orange">
        <div class="page-vipRights_index-icon">
          <img src="~assets/img/right/13.png" alt="专属标识" />
          <div>专属标识</div>
        </div>
      </div>
      <div class="w240 h180 fl mr16 block orange">
        <div class="page-vipRights_index-icon">
          <img src="~assets/img/right/14.png" alt="新游体验" />
          <div>新游体验</div>
        </div>
      </div>
      <div class="w240 h180 fl block orange">
        <div class="page-vipRights_index-icon">
          <img src="~assets/img/right/15.png" alt="生日关怀" />
          <div>生日关怀</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VipIcon from '~/components/logic-common/VipIcon'
import Logout from '~/components/logic-common/Logout'
export default {
  layout: 'vip-rights',
  components: {
    VipIcon,
    Logout
  },
  data() {
    return {
      swiperOptions: {
        // effect: 'fade',
        onlyExternal: false,
        autoplay: 5000,
        loop: true
      },
      swiperList: []
    }
  },
  inject: ['userLevel'],
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
    levelConf() {
      return this.$store.state.app.levelConf
    },
    barStyle() {
      const { level, exp } = this.userLevel()
      const min = this.levelConf[`vip${level}`]
      const max = this.levelConf[`vip${level + 1}`]
      if (!this.levelConf.vip1) return {}
      if (!min) {
        const percent = Math.min((exp / this.levelConf.vip1.exp) * 100, 100)
        return { width: percent + '%' }
      }
      if (!max) return { width: '100%' }

      const percent = Math.min(
        ((exp - min.exp) / (max.exp - min.exp)) * 100,
        100
      )
      return {
        width: percent + '%'
      }
    }
  },
  mounted() {
    this.$xlaPush('vip_privilege_page_show')
  },
  methods: {
    clientCreated() {
      this.fetchSwiperList()
    },
    fetchSwiperList() {
      this.$request('userExpCarousel').then(
        (data = []) => (this.swiperList = data)
      )
    }
  }
}
</script>

<style lang="scss" src="~/assets/scss/vip-rights.scss"></style>
